import {useContext} from 'react';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {Button} from '~library/atoms/Button';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const ResetImageXY = ({label, dataQaId, uyoImage, disabled = false}) => {
  const {canvas} = useContext(EventCreateContext);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;

  const resetUYOImage = () => {
    const rect = canvas.getObjects().find((obj) => obj.type === 'rect' && obj.id === uyoImage.id);
    const effectiveWidth = rect.width * rect.scaleX;
    const effectiveHeight = rect.height * rect.scaleY;
    const scaleX = effectiveWidth / uyoImage.width;
    const scaleY = effectiveHeight / uyoImage.height;
    const scale = Math.min(scaleX, scaleY);

    const centerX = rect.left + (rect.width * rect.scaleX) / 2;
    const centerY = rect.top + (rect.height * rect.scaleY) / 2;

    uyoImage.scale(scale).set({
      left: centerX,
      top: centerY,
      originX: 'center',
      originY: 'center',
      centeredRotation: true,
      hasControls: true,
      _originalObject: rect.toJSON(),
    });

    uyoImage.rotate(0);

    canvas.setActiveObject(uyoImage);
    canvas.renderAll();
    canvas.fire('object:modified');
  };

  return (
    <Button
      onClick={resetUYOImage}
      data-qa-id={dataQaId}
      variant="link"
      size="small"
      className="reset_all__button"
      disabled={disabled}
    >
      {isMobile ? 'Reset' : label}
    </Button>
  );
};
